<template>
  <v-container :fill-height='loading'>
   <v-layout v-if="loading"
      align-center
      justify-space-around
      wrap
      fill-height
    style="background:var(--background-grey); height:100vh;"
      >
      <v-progress-circular
          indeterminate
          color="primary"
          :size="50">
          </v-progress-circular>
      </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <div class="add-page-head ">
          <span :class="{'display-4 section-head d-block' : $vuetify.breakpoint.xsOnly, 'display-3 section-head d-block' : !$vuetify.breakpoint.xsOnly}">Archive</span>
          <span class="body-small font-weight-bold pt-1 d-block">View and search your archived jobs</span>
        </div>
      </v-flex>
      <v-flex xs12 v-if="error">
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
      <v-flex xs12>
          <div class="app-panel" :class="{'white px-1 pb-5 pt-4' : $vuetify.breakpoint.xsOnly, 'white px-3 pb-5 pt-4' : !$vuetify.breakpoint.xsOnly}">
          <v-layout :class="{'px-3 pb-3' : $vuetify.breakpoint.xsOnly, 'px-0 pb-5 ' : !$vuetify.breakpoint.xsOnly}">
            <v-flex >
                <v-text-field
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  :autofocus="!$vuetify.breakpoint.xsOnly"
                  clearable
                  v-model="search"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout v-if="selected.length > 0">
              <v-flex>
                <v-btn
                  color="primary"
                  class="white--text"
                  @click="deleteSelected"
                  :disabled="selected.length === 0"
                  depressed
                >
                  Delete selected jobs
                </v-btn>
                <p class="pt-2 caption light">(Deleting a job from the archive does not affect any associated invoices.)</p>
              </v-flex>
            </v-layout>
          <v-data-table
              :headers="headers"
              :items="archivedJobs"
              hide-actions
              :search="search"
              class="datatable"
              :pagination.sync="pagination"
              :loading="loading"
              select-all
              v-model="selected"
            >
            <template slot="items" slot-scope="props" >
              <tr
               >
              <td>
                <v-checkbox
                  v-model="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </td>
                <td
                class="text-xs-left body-small"
                @click="showTheCard(props.item)"
                style="cursor:pointer;"
                >{{ props.item.clientName }}</td>
                <td
                class="text-xs-left body-small pt-1 pb-1"
                @click="showTheCard(props.item)"
                style="cursor:pointer;"
                >{{ props.item.title }}</td>
                <td
                class="text-xs-left body-small"
                @click="showTheCard(props.item)"
                style="cursor:pointer;"
                ><display-amount :totalAmount="props.item.amount" :totalNetAmount="props.item.totalNetAmount"></display-amount></td>
                <td
                class="text-xs-left body-small"
                @click="showTheCard(props.item)"
                style="cursor:pointer;"
                >{{ formatDateToDateAndMins(props.item.archived_date) }} </td>
              </tr>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </div>
        </v-flex>
  </v-layout>
  <confirm ref="confirm"></confirm>
  <job-detail-modal></job-detail-modal>
</v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import Confirm from '@/components/Shared/Confirm'
import JobDetailModal from '@/components/Shared/JobDetailModal'
import { formatDate } from '@/components/Mixins/formatDate'
import DisplayAmount from '@/components/Shared/DisplayAmount'

export default {
  components: {
    DisplayAmount,
    JobDetailModal,
    Confirm
  },
  mixins: [formatDate],
  data () {
    return {
      selected: [],
      search: '',
      pagination: {
        descending: true,
        rowsPerPage: -1,
        sortBy: 'archived_date'
      },
      headers: [
        { text: 'Client', value: 'clientName', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Job title', value: 'title', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Total', value: 'amount', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Archived Date', value: 'archived_date', align: 'left', class: 'body-2 font-weight-bold' }
      ],
      user: this.$store.getters.user,
      archivedJobs: [],
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    pagination (newName) {
      localStorage.invOrderBy = newName
      const parsed = JSON.stringify(newName)
      localStorage.setItem('arch-pagination', parsed)
    }
  },
  methods: {
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.desserts.slice()
    },
    fetchData () {
      // get  jobs from firebase and listen
      this.$store.commit('setLoading', true)
      firebase.database().ref(`lists/${this.user.group}/list6`).on('value', (data) => {
        const jobs = []
        const obj = data.val()
        for (let key in obj) {
          jobs.push(obj[key])
        }
        this.archivedJobs = jobs
      })
      this.$store.commit('setLoading', false)
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    showTheCard (job) {
      this.$store.commit('setJobDetailModalJob', job)
      this.$store.commit('toggleShowJobDetailModal')
    },
    async restoreSelected () {
      this.$store.commit('setLoading', true)
      this.selected.forEach((job) => {
        console.log('job', job)
        const archivedFrom = job.archived_from
        job.archived_date = null
        job.archived_from = null
        firebase.database().ref(`lists/${this.user.group}/list6/${job.id}`).update({
          archived_date: null,
          archived_from: null
        })
        this.$store.dispatch('moveJob', { jobId: job.id, oldList: 6, newList: archivedFrom })
      })
      this.$store.commit('setLoading', false)
      this.$store.dispatch('addNotification', { text: 'Jobs restored successfully.', type: 'primary' })
    },
    async deleteSelected () {
      if (await this.$refs.confirm.open('Delete', 'Are you sure you want to permanently delete these jobs?', { color: 'red' })) {
        this.$store.commit('setLoading', true)
        this.selected.forEach((job) => {
          firebase.database().ref(`lists/${this.user.group}/list6/${job.id}`).remove()
        })
        this.$store.commit('setLoading', false)
        this.$store.dispatch('addNotification', { text: 'Jobs deleted successfully.', type: 'primary' })
      }
    }
  },
  mounted () {
    if (localStorage.getItem('arch-pagination')) {
      try {
        this.pagination = JSON.parse(localStorage.getItem('arch-pagination'))
      } catch (e) {
        localStorage.removeItem('arch-pagination')
      }
    }
  },
  onBeforeRouteLeave () {
    firebase.database().ref(`lists/${this.user.group}/list6`).off()
  },
  created () {
    this.fetchData()
  }
}
</script>
